export default __webpack_public_path__ + "static/media/world-mode-options-title.70489ff9.png";